import CryptoJS from 'crypto-js';

const secretKey = process.env.REACT_APP_SECRET_KEY_LOCALSTORAGE;

export default function dataDecrypt(value, session) {


  try {
    const bytes = CryptoJS.AES.decrypt(
      session ? value.PPDCH : value.PPDUO,
      secretKey
    );
    return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  } catch (error) {
    // console.log('🚀🚀🚀🚀 ~ file: data-decrypt.js:9 ~ dataDecrypt ~ error:', error);
    // document.location.href = POSTURL;
  }
}